import { ProvisioningType, ThingActivity } from '@eagle/core-data-types';
import { Nullable, Undefinable } from '../../types';
import { ActivityType } from './entity-card';

export interface TrustedActivityRule {
  include: Undefinable<boolean>;
  allowedProvisioning: Undefinable<Nullable<ProvisioningType[]>>;
  maxDurationMinutes: Undefinable<Nullable<number>>;
  minDurationSeconds?: Undefinable<Nullable<number>>;
  ongoingMaxMinutes: Undefinable<Nullable<number>>;
}

export interface TrustedActivitiesRules {
  activityTypes: Record<string, TrustedActivityRule>;
  defaults: TrustedActivityRule;
}

export const filterTrustedActivities = (activities: ThingActivity[], rules: Nullable<TrustedActivitiesRules>, now: Date = new Date()): ThingActivity[] => {
  if (!rules) return activities;

  return activities.filter((activity) => {
    try {
      const activityType = activity.activityType as ActivityType;
      const rule = rules.activityTypes[activityType] || rules.defaults;

      if (!rule.include) return false;

      if (rule.allowedProvisioning && rule.allowedProvisioning.length > 0) {
        const allowed = rule.allowedProvisioning;

        const startProvisioning = activity.startProvisioningType ?? null;
        const finishProvisioning = activity.finishProvisioningType ?? null;

        const isAllowed = (prov: Nullable<ProvisioningType>): boolean => prov !== null && allowed.includes(prov);

        if (activity.finish) {
          if (!isAllowed(startProvisioning) || !isAllowed(finishProvisioning)) return false;
        } else {
          if (!isAllowed(startProvisioning)) return false;
        }
      }

      if (activity.finish) {
        const startMs = activity.start.getTime();
        const endMs = (activity.finish ? activity.finish.getTime() : now.getTime());
        const durationMinutes = (endMs - startMs) / (1000 * 60);
        const durationSeconds = (endMs - startMs) / 1000;

        if (rule.maxDurationMinutes && durationMinutes > rule.maxDurationMinutes) {
          return false;
        }

        if (rule.minDurationSeconds !== undefined && rule.minDurationSeconds !== null && durationSeconds < rule.minDurationSeconds) {
          return false;
        }
      } else {
        const ongoingMinutes = (now.getTime() - activity.start.getTime()) / (1000 * 60);

        if (rule.ongoingMaxMinutes && ongoingMinutes > rule.ongoingMaxMinutes) {
          return false;
        }
      }
      return true;
    } catch (error) {
      console.warn('Error validating trusted activity:', error);
      return false;
    }
  });
};
